<template>
  <div class="multi-terminal-adapt">
    <div class="content-center">
      <div class="module-header">
        <div class="module-title">多终端适配·让项目更清晰</div>
        <div class="module-subtitle">支持多端适配，PC移动一体化，支持鸿蒙、ios、小程序和Android，随时查看最新进度</div>
      </div>
      <div class="module-body">
        <div class="terminal-item angle">
          <img class="terminal-item-icon" src="@/assets/img/home/MultiTerminalAdapt/icon_app.png">
          <div class="terminal-item-text">IOS/Android/鸿蒙</div>
          <div class="terminal-item-qrcode">
            <img class="qrcode-img" src="https://open.591ylc.com/install/qr.png">
          </div>
        </div>
        <div class="terminal-item">
          <img class="terminal-item-icon" src="@/assets/img/home/MultiTerminalAdapt/icon_web.png">
          <div class="terminal-item-text">WEB网站</div>
        </div>
        <div class="terminal-item angle">
          <img class="terminal-item-icon" src="@/assets/img/home/MultiTerminalAdapt/icon_weixin.png">
          <div class="terminal-item-text">微信小程序</div>
          <div class="terminal-item-qrcode">
            <img class="qrcode-img" src="@/assets/img/qrcode/mini_program.png">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
};
</script>

<style lang="less" scoped>
.multi-terminal-adapt {
  padding: 64px 0;

  .content-center {
    .module-body {
      padding: 40px 0 900px;
      background-image: url('@/assets/img/home/MultiTerminalAdapt/background.png');
      background-position: center bottom;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: center;
      .terminal-item {
        width: 104px;
        height: 104px;
        padding: 14px 6px 0;
        background: #FFFFFF;
        box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1);
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        overflow: hidden;
        user-select: none;
        &.angle {
          background-image: url('@/assets/img/home/MultiTerminalAdapt/qrcode_angle.png');
          background-position: right top;
          background-repeat: no-repeat;
        }
        + .terminal-item {
          margin-left: 133px;
        }
        .terminal-item-icon {
          width: 40px;
          height: 40px;
        }
        .terminal-item-text {
          margin-top: 6px;
          font-size: 14px;
          text-align: center;
        }
        .terminal-item-qrcode {
          width: 0;
          height: 0;
          background-color: #fff;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
          overflow: hidden;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          transition: 0.3s;
          .qrcode-img {
            width: 100px;
            height: 100px;
          }
        }
        &:hover .terminal-item-qrcode {
          width: 150px;
          height: 150px;
          opacity: 1;
        }
      }
    }
  }
}
</style>
